import { useQuery } from 'react-query';
import {
  type GetBettieProductsResponse,
  getBettieProducts
} from '../../services/bettiePaymentService';

interface GetBettieProductsParams {
  category?: 'onetime' | 'subscription' | 'bundle';
  assetType?: 'bettie_point' | 'bettie_chat_room_ticket';
}

export function useGetBettieProducts(parameters: GetBettieProductsParams) {
  const params = {
    category: parameters.category,
    asset_type: parameters.assetType
  };
  return useQuery<GetBettieProductsResponse>(
    ['bettie-products', params],
    () => getBettieProducts(params),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
